import * as estimationTypes from '@/constants/estimation_types';

export default {
  data() {
    return {
      useNullableEstimationType: true,
    };
  },
  computed: {
    estimationTypeItems() {
      const items = [];
      if (this.useNullableEstimationType) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(estimationTypes)
        .forEach((key) => {
          if (key !== 'ESTIMATION_TYPES') {
            items.push({
              text: this.lang(this.$store, `sap/listings.global.filter.estimation_types.${estimationTypes[key]}`),
              value: estimationTypes[key],
            });
          }
        });
      return items;
    },
  },
};
